import TaxiCorporationOrderBillingsDownloadRequest, {
  TaxiCorporationOrderBillingsDownloadRequestStatus,
  TaxiCorporationOrderBillingsDownloadRequestOrder,
  TaxiCorporationOrderBillingsDownloadRequestBillingModel,
  TaxiCorporationOrderBillingsDownloadRequestBillingType,
} from "../../../../api/raily/taxi-corporation/order-billings/download/taxi-corporation-order-billings-download.request";
import BillingModel from "../../../../types/billing-model";
import BillingStatus from "../../../../types/billing-status";
import TaxiCorporationBillingType from "../../../../types/taxi-corporation-billing-type";
import TaxiCorporationOrderBillingsDownloadParams, {
  TaxiCorporationOrderBillingsDownloadParamsOrder,
} from "./taxi-corporation-order-billings-download-params";

const createBillingModel = (
  billingModel: BillingModel | undefined,
): TaxiCorporationOrderBillingsDownloadRequestBillingModel | undefined => {
  switch (billingModel) {
    case BillingModel.AB:
      return TaxiCorporationOrderBillingsDownloadRequestBillingModel.AB;
    case BillingModel.ABA:
      return TaxiCorporationOrderBillingsDownloadRequestBillingModel.ABA;
    case BillingModel.OTHER:
      return TaxiCorporationOrderBillingsDownloadRequestBillingModel.OTHER;
    case BillingModel.SABS:
      return TaxiCorporationOrderBillingsDownloadRequestBillingModel.SABS;
    default:
      return undefined;
  }
};

const createBillingType = (
  billingType: TaxiCorporationBillingType | undefined,
): TaxiCorporationOrderBillingsDownloadRequestBillingType | undefined => {
  switch (billingType) {
    case TaxiCorporationBillingType.PRIV_CARGO_2_TAXI:
      return TaxiCorporationOrderBillingsDownloadRequestBillingType.PRIV_CARGO_2_TAXI;
    case TaxiCorporationBillingType.PRIV_TAXI_2_RAILY:
      return TaxiCorporationOrderBillingsDownloadRequestBillingType.PRIV_TAXI_2_RAILY;
    case TaxiCorporationBillingType.PUB_RAILY_2_TAXI:
      return TaxiCorporationOrderBillingsDownloadRequestBillingType.PUB_RAILY_2_TAXI;
      return undefined;
  }
};

const createStatus = (
  status: BillingStatus | undefined,
): TaxiCorporationOrderBillingsDownloadRequestStatus | undefined => {
  switch (status) {
    case BillingStatus.CREATED:
      return TaxiCorporationOrderBillingsDownloadRequestStatus.CREATED;
    case BillingStatus.ACCEPTED:
      return TaxiCorporationOrderBillingsDownloadRequestStatus.ACCEPTED;
    case BillingStatus.REJECTED:
      return TaxiCorporationOrderBillingsDownloadRequestStatus.REJECTED;
    case BillingStatus.REOPEN_REQUEST:
      return TaxiCorporationOrderBillingsDownloadRequestStatus.REOPEN_REQUEST;
    case BillingStatus.REOPENED:
      return TaxiCorporationOrderBillingsDownloadRequestStatus.REOPENED;
    default:
      return undefined;
  }
};

const createOrder = (
  order: TaxiCorporationOrderBillingsDownloadParamsOrder | undefined,
): TaxiCorporationOrderBillingsDownloadRequestOrder | undefined => {
  switch (order) {
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DATE_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DATE_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DATE_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DATE_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.HUMAN_ID_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.HUMAN_ID_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.HUMAN_ID_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.HUMAN_ID_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DISTANCE_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DISTANCE_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DISTANCE_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DISTANCE_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DISTANCE_RATE_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DISTANCE_RATE_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DISTANCE_RATE_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DISTANCE_RATE_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DISTANCE_AMOUNT_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DISTANCE_AMOUNT_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.DISTANCE_AMOUNT_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.DISTANCE_AMOUNT_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.HALTING_AMOUNT_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.HALTING_AMOUNT_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.HALTING_AMOUNT_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.HALTING_AMOUNT_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.HIGHWAY_CHARGE_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.HIGHWAY_CHARGE_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.HIGHWAY_CHARGE_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.HIGHWAY_CHARGE_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.TOTAL_AMOUNT_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.TOTAL_AMOUNT_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.TOTAL_AMOUNT_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.TOTAL_AMOUNT_DESC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.BILLING_MODEL_ASC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.BILLING_MODEL_ASC;
    case TaxiCorporationOrderBillingsDownloadParamsOrder.BILLING_MODEL_DESC:
      return TaxiCorporationOrderBillingsDownloadRequestOrder.BILLING_MODEL_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: TaxiCorporationOrderBillingsDownloadParams,
): TaxiCorporationOrderBillingsDownloadRequest => {
  return {
    billingModel: createBillingModel(params.billingModel),
    billingType: createBillingType(params.billingType),
    cargoCompany: params.cargoCompany,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    excludeCargoCompany: params.excludeCargoCompany,
    humanId: params.humanId,
    order: createOrder(params.order),
    passenger: params.passenger,
    planEntryHumanIds: params.planEntryHumanIds,
    responsibleTaxi: params.responsibleTaxi,
    status: createStatus(params.status),
    taxiCorporationUuid: params.taxiCorporationUuid,
  };
};

const taxiCorporationOrderBillingsDownloadParamsFactory = {
  create,
};

export default taxiCorporationOrderBillingsDownloadParamsFactory;
